<template>
  <div class="video-player">
    <video
      class="player-container-id"
      :poster="coverUrl || defaultPhoto"
      :key="id"
      :src="url"
      controls
      controlslist="nodownload noremoteplayback noplaybackrate foobar"
      disablepictureinpicture
      ref="videoPlayer"
      @loadedmetadata="onLoadedMetadata"
      @play="handleVideo"
      :id="id"
      playsinline
      webkit-playsinline
      allowfullscreen="true"
    ></video>
    <div class="poster-wrapper" ref="videoPoster" @click="handlePlay()">
      <img :src="coverUrl || defaultPhoto" alt="" />
      <div class="play">
        <i class="iconfont icon-icon_shequzhongxin_bofang"></i>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { isFeishu } from '@/utils/feishu'
import { device } from '@/utils/Device'

const props = defineProps<{
  id: string | undefined
  url: string | undefined
  coverUrl: string | undefined
  boardId: string
  rollVideoId: string
}>()
const { t } = useI18n()
const videoPlayer = ref()
const videoPoster = ref()
const showPlay = ref(true)
const defaultPhoto = require('@/assets/images/defalut_upload_cover.png')
const router = useRouter()
const handlePlay = () => {
  if (!device() && isFeishu) {
    router.push({
      path: '/rollVideo',
      query: {
        sortType: 0,
        id: props.rollVideoId,
        boardId: props.boardId
      }
    })
  } else {
    videoPlayer.value?.play()
    showPlay.value = false
    videoPoster.value.style.display = 'none'
  }
}
// loadedmetadata事件监听器
const onLoadedMetadata = () => {
  showPlay.value = true
  // document.addEventListener('DOMContentLoaded', function() {
  try {
    if (videoPlayer.value) {
      observer.observe(videoPlayer.value)
    }
  } catch (error) {}
  // })
}

const observer = new IntersectionObserver(
  (entries) => {
    if (entries[0].isIntersecting) {
      // showPlay.value = false
    } else {
      if (videoPlayer?.value) {
        videoPlayer?.value.pause()
        videoPoster.value.style.display = 'block'
      }
      showPlay.value = true
    }
  },
  { threshold: 0.5 }
)

const handleVideo = () => {
  if (props.url === '') {
    showToast(t('community_video_loseTip'))
    return
  }
  showPlay.value = false
  // 只能同时播放一个视频
  const videos = Array.from(document.getElementsByTagName('video'))
  const posters = Array.prototype.slice.call(document.getElementsByClassName('poster-wrapper'))
  videos?.forEach((video: HTMLVideoElement, index: number) => {
    video.addEventListener('play', () => {
      pauseAll(index)
    })
  })
  function pauseAll(index: number) {
    videos?.forEach((video: HTMLVideoElement, i: number) => {
      if (i !== index) {
        video.pause()
        posters[i].style.display = 'block'
      }
    })
  }
}
</script>

<style scoped lang="less">
@oneImgWidth: calc(100vw - 32px - 24px);
.video-player {
  position: relative;
  .total-timer {
    font-size: 12px;
    color: #fff;
  }
  .player-container-id {
    width: 100%;
    max-height: calc(@oneImgWidth * 0.75);
    object-fit: contain;
    background: #000;
    border-radius: 4px;
    .down_icon {
      font-weight: 700;
      font-size: 14px;
      padding: 10px;
      background: pink;
      color: #fff;
    }
    :deep(.vjs-custom-control-spacer) {
      display: none !important;
    }
    :deep(.vjs-progress-control) {
      flex: 1 !important;
      position: static !important;
      left: unset !important;
      height: unset !important;
      top: unset !important;
    }
    :deep(.vjs-poster) {
      background-size: cover;
    }
  }
  .play {
    position: absolute;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    opacity: 0.5;
    padding-left: 19px;
    background: #000;
    display: flex;
    align-items: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    .iconfont {
      font-size: 20px;
      color: #fff;
    }
  }
  video::-webkit-media-controls-mute-button {
    display: none !important;
  }
  // video::-webkit-media-controls-fullscreen-button {
  //   display: 'none';
  // }
  .poster-wrapper {
    width: 100%;
    max-height: calc(@oneImgWidth * 0.75);
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
